import { Pill } from 'components/ManagementCard'
import { EMPTY_VALUE } from 'constants/index'
import { accountManagementStrings } from 'constants/strings'
import type { TTermsMemberConsentState } from 'types/terms'

const toneByState = {
  NOT_APPLICABLE: 'neutral',
  EXEMPT: 'neutral',
  VERIFICATION: 'accent',
  PENDING: 'warning',
  REACCEPTANCE_PENDING: 'warning',
  ACCEPTED: 'success',
} as const

/** アカウントの利用規約の同意状態（動作確認中・同意待ち・再同意待ち・同意済み） */
export function TermsStateBadge({
  state,
}: {
  state: TTermsMemberConsentState | undefined
}) {
  if (!state) return <span className="text-[11px] text-muted">{EMPTY_VALUE}</span>
  return (
    <Pill tone={toneByState[state]}>
      {accountManagementStrings.terms.states[state]}
    </Pill>
  )
}
